import { useMutation } from '@apollo/client';
import { Button } from '@fluentui/react-components';
import React from 'react';
import {
  ANALYZE_DOCUMENTS,
  GET_RUNS_FOR_DOCUMENT,
} from '../../../utils/statApi/DocumentAnalysisApi';
import CanAccess from '../../common/canAccess/CanAccess';

interface IAnalyzeButtonProps {
  documentId: number;
}

const AnalyzeButton = (props: IAnalyzeButtonProps): JSX.Element => {
  const { documentId } = props;

  const [analyze, { loading }] = useMutation(ANALYZE_DOCUMENTS, {
    refetchQueries: [GET_RUNS_FOR_DOCUMENT],
  });

  const onClick = (): void => {
    analyze({
      variables: {
        createAnalysisRunsDto: {
          documentIds: [documentId],
        },
      },
    });
  };

  return (
    <CanAccess requestedAction="DocumentAnalysis:Create" notAuthorizedChildren={<div />}>
      <Button appearance="primary" disabled={loading} onClick={onClick}>
        Analyze
      </Button>
    </CanAccess>
  );
};

export default AnalyzeButton;
